var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ]
    },
    [
      !_vm.open
        ? _c("div", { staticStyle: { height: "500px" } }, [
            _vm._v("商家暂未加入平台化服务。")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.open
        ? _c(
            "el-form",
            { attrs: { model: _vm.form, "label-width": "140px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "是否平台化商家" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.form.is_platform,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "is_platform", $$v)
                        },
                        expression: "form.is_platform"
                      }
                    },
                    [
                      _c("el-option", { attrs: { label: "开启", value: "1" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "关闭", value: "0" } })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.is_platform == 0,
                          expression: "form.is_platform == 0"
                        }
                      ],
                      staticStyle: { color: "red", display: "inline" }
                    },
                    [
                      _vm._v(
                        "\n        “关闭”平台化服务并提交后，下面所有设置也同时为关闭、失效。\n      "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "平台化等级" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: _vm.closePf },
                      model: {
                        value: _vm.form.sale_level,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "sale_level", $$v)
                        },
                        expression: "form.sale_level"
                      }
                    },
                    _vm._l(_vm.sale_levels, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { color: "#888", display: "inline" } },
                    [
                      _vm._v(
                        "\n        系统每月根据商家表现自动调整等级，手动修改只对当前自然月生效。\n      "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "一手APP是否展示“严选品牌”标签",
                    required: ""
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: _vm.closePf },
                      model: {
                        value: _vm.form.is_show_best_choice,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "is_show_best_choice", $$v)
                        },
                        expression: "form.is_show_best_choice"
                      }
                    },
                    [
                      _c("el-option", { attrs: { label: "展示", value: "1" } }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "不展示", value: "2" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "合同模式", required: "" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: _vm.closePf },
                      model: {
                        value: _vm.form.contract_type_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "contract_type_id", $$v)
                        },
                        expression: "form.contract_type_id"
                      }
                    },
                    _vm._l(_vm.contract_type, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { border: "1px solid #ccc" } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "background-color": "#f8f8f8",
                      "border-bottom": "1px solid #ccc",
                      padding: "5px 10px"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { "margin-bottom": "0" },
                        attrs: { label: "平台佣金扣取" }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { disabled: _vm.closePf },
                            model: {
                              value: _vm.form.platform_switch,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "platform_switch", $$v)
                              },
                              expression: "form.platform_switch"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "开启", value: "1" }
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "关闭", value: "2" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { padding: "20px" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "平台协议日期" } },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            "value-format": "yyyy-MM-dd",
                            disabled: _vm.disabledPlatform,
                            "picker-options": _vm.pickerOptions
                          },
                          model: {
                            value: _vm.form.platform_begin_time,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "platform_begin_time", $$v)
                            },
                            expression: "form.platform_begin_time"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  !_vm.disabledPlatform &&
                                  _vm.form.platform_begin_time,
                                expression:
                                  "!disabledPlatform && form.platform_begin_time"
                              }
                            ],
                            staticStyle: { display: "inline", color: "#888" }
                          },
                          [
                            _vm._v("\n            从"),
                            _c("span", { staticStyle: { color: "blue" } }, [
                              _vm._v(_vm._s(_vm.toDay) + " 7:00")
                            ]),
                            _vm._v(
                              "的专场开始享受到平台化商家政策流量，代采开单将对计划生成时间从"
                            ),
                            _c("span", { staticStyle: { color: "blue" } }, [
                              _vm._v(_vm._s(_vm.nextDay) + " 7:00")
                            ]),
                            _vm._v(
                              "开始，进行平台佣金的代采订单扣费。\n          "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "平台佣金比例(%)" } },
                      [
                        _c("el-inputNumber", {
                          staticStyle: { width: "220px" },
                          attrs: {
                            min: 0.0,
                            max: 100.0,
                            precision: 2,
                            disabled: _vm.disabledPlatform
                          },
                          model: {
                            value: _vm.form.service_fee_rate,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "service_fee_rate", $$v)
                            },
                            expression: "form.service_fee_rate"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-top": "30px", "margin-left": "160px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.submit }
                },
                [_vm._v("提交")]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16e80e7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16e80e7a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/supply/updateSupplyComponents/Platforming.vue
// module id = null
// module chunks = 